var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "yxtbiz-ai-robot__dialog--msg is-answer",
      class: {
        "is-long-size": _vm.isSearch,
        "bbs-search": _vm.mode === "bbs",
        fullscreen: _vm.fullscreen,
      },
    },
    [
      _vm.showPortrait
        ? _c(
            "div",
            { class: { "head-img": _vm.isSearch, mr12: !_vm.isSearch } },
            [
              _c("yxtf-portrait", {
                class: { hand: _vm.isSearch },
                attrs: { size: "28px", imgUrl: _vm.settings.assistHeadImg },
                on: {
                  click: function ($event) {
                    _vm.isSearch && !_vm.isWaitAnswer && _vm.$emit("launch")
                  },
                },
              }),
              _vm.isSearch ? _c("span", [_vm._v("问一问")]) : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(_vm.anserComponents, {
        tag: "component",
        attrs: {
          msg: _vm.msg,
          isWaitAnswer: _vm.isWaitAnswer,
          isSearch: _vm.isSearch,
          fullscreen: _vm.fullscreen,
          lastMsg: _vm.lastMsg,
        },
        on: {
          resend: (val) => _vm.$emit("resend", val),
          feedback: function ($event) {
            return _vm.$emit("feedback")
          },
          PromotClick: _vm.PromotClick,
          scrollToEnd: function ($event) {
            return _vm.$emit("scrollToEnd")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }